module.exports = __webpack_public_path__ + "static/media/galerija_2017 (25).693013ed.jpg";